// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s5xT","buttons":"styles_buttons__31yP6"};